import { Rpc } from "../rpc";
import { ValueWrapper } from "../ValueWrapper";

export class ProfileRpc {

    public static get(): Promise<ProfileResponse> {
        return Rpc.GET("/rpc/profile/get");
    }

    public static save(req: SaveProfileRequest): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/profile/save", req);
    }

    public static uploadImage(imageBase64: string): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/profile/uploadImage", { imageBase64: imageBase64 });
    }

    private constructor() {}

}

export interface ProfileResponse {

    readonly pictureUrl: string;
    readonly name: string;
    readonly team: string;
    readonly position?: string;
    readonly bio?: string;
    readonly email: string;
    readonly chatAddress: string;
    readonly homePhone: string;
    readonly workPhone: string;
    readonly address: string;
    readonly memberSince: string;

}

export interface SaveProfileRequest {

    name: string;
    position: string;
    bio: string;
    chat: string;
    workPhone: string;
    homePhone: string;
    address: string;
    memberSince: string;

}
